/**
 * SRM product gallery prev/next controls.
 * Dawn hides inactive thumbnail-slider slides on desktop, so the native
 * slider-component cannot scroll. These controls cycle media via media-gallery.
 */
(function () {
  function getTargets(gallery) {
    const thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item[data-target]'));
    if (thumbs.length) {
      return thumbs.map((item) => item.getAttribute('data-target'));
    }

    return Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]')).map((item) =>
      item.getAttribute('data-media-id')
    );
  }

  function getActiveIndex(gallery, targets) {
    const currentThumb = gallery.querySelector('.thumbnail-list__item [aria-current="true"]');
    if (currentThumb) {
      const target = currentThumb.closest('[data-target]')?.getAttribute('data-target');
      const index = targets.indexOf(target);
      if (index >= 0) return index;
    }

    const activeMedia = gallery.querySelector('.product__media-item.is-active[data-media-id]');
    if (activeMedia) {
      const index = targets.indexOf(activeMedia.getAttribute('data-media-id'));
      if (index >= 0) return index;
    }

    return 0;
  }

  function setActive(gallery, mediaId) {
    if (!mediaId) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
      return;
    }

    const thumbButton = gallery.querySelector(`.thumbnail-list__item[data-target="${mediaId}"] button`);
    if (thumbButton) {
      thumbButton.click();
      return;
    }

    gallery.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => {
      item.classList.toggle('is-active', item.getAttribute('data-media-id') === mediaId);
    });
  }

  function unlock(button) {
    if (button && button.hasAttribute('disabled')) {
      button.removeAttribute('disabled');
    }
  }

  function bindGallery(gallery) {
    if (gallery.dataset.srmMediaNavBound === 'true') return;

    const viewer = gallery.querySelector('.srm-media-viewer');
    if (!viewer) return;

    const prev = viewer.querySelector('.srm-media-nav-btn[name="previous"]');
    const next = viewer.querySelector('.srm-media-nav-btn[name="next"]');
    if (!prev || !next) return;

    gallery.dataset.srmMediaNavBound = 'true';

    const go = (delta, event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const targets = getTargets(gallery);
      if (targets.length < 2) return;

      const current = getActiveIndex(gallery, targets);
      const nextIndex = (current + delta + targets.length) % targets.length;
      setActive(gallery, targets[nextIndex]);
      unlock(prev);
      unlock(next);
    };

    prev.addEventListener('click', (event) => go(-1, event), true);
    next.addEventListener('click', (event) => go(1, event), true);

    const keepEnabled = () => {
      unlock(prev);
      unlock(next);
    };

    keepEnabled();
    new MutationObserver(keepEnabled).observe(prev, { attributes: true, attributeFilter: ['disabled'] });
    new MutationObserver(keepEnabled).observe(next, { attributes: true, attributeFilter: ['disabled'] });
  }

  function init() {
    document.querySelectorAll('.srm-product-page media-gallery').forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
